import * as authActionCreators from '../../../redux/modules/auth';

const mapStateToProps = state => ({
  auth: state.auth,
  requestStats: state.travelExpense.requestStats
});

const mapDispatchToProps = {
  ...authActionCreators
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/user/info/index.js